<template>
  <div
    :class="isContrast != 'false' && isContrast != false ? 'high-contrast' : ''"
  >
    <div class="homepage-main-container homepage-main">
      <span class="curr-nav">{{ t("navbar.dashboard") }} </span>
      <span class="homepage-title bold-font row">{{
        t("navbar.dashboard")
      }}</span>
      <div class="homepage-container">
        <div class="row justify-between">
          <SchemesList
            :schemesProp="newestSchemes.results"
            :title="t('my_dashboard.latest_schemes')"
            :isLoading="isLoadingNewestSchemes"
          />

          <SchemesList
            :schemesProp="deadlineSchemes.results"
            :title="t('my_dashboard.upcoming_deadlines')"
            :isLoading="isLoadingDeadlineSchemes"
          />
        </div>

        <div class="row">
          <NewsList
            :newsProp="latestNews.results"
            :title="t('my_dashboard.latest_news')"
            :isLoading="isLoadingLatestNews"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SchemesList from "../components/homepage-components/SchemesList.vue";
import { onMounted, computed, ref } from "vue";
import SchemesUtils from "../utils/schemes";
import NewsUtils from "../utils/news";
import store from "../store/index";
import NewsList from "../components/homepage-components/NewsList.vue";
import UserService from "../services/userprofile.service";
import { useI18n } from "vue-i18n";
import mailingService from "../services/mailing.service";
export default {
  name: "HomePage",

  components: {
    SchemesList,
    NewsList,
  },
  setup() {
    const { t, locale } = useI18n();
    const isLoadingLatestNews = computed({
      get: () => store.state.grantItems.isLoadingLatestNews,
      set: (val) => {
        store.commit("grantItems/updateLatestNewsLoading", val);
      },
    });
    const isLoadingNewestSchemes = computed({
      get: () => store.state.grantItems.isLoadingNewestSchemes,
      set: (val) => {
        store.commit("grantItems/updateNewestSchemesLoading", val);
      },
    });
    const isLoadingDeadlineSchemes = computed({
      get: () => store.state.grantItems.isLoadingDeadlineSchemes,
      set: (val) => {
        store.commit("grantItems/updateDeadlineSchemesLoading", val);
      },
    });
    const newestSchemes = computed({
      get: () => store.state.grantItems.newestGrants,
    });

    const latestNews = computed({
      get: () => store.state.news.latestNews,
    });

    const deadlineSchemes = computed({
      get: () => store.state.grantItems.deadlineGrants,
    });

    const significantChangesShemes = computed({
      get: () => store.state.grantItems.significantChangesGrants,
    });

    const favoriteAudience = computed({
      get: () => store.state.user.favoriteAudiencesIdsArray,
    });
    const favoritePurposes = computed({
      get: () => store.state.user.favoritePurposesIdsArray,
    });
    const favoriteLocations = computed({
      get: () => store.state.user.selectedFavoriteLocations,
    });
    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });
    const authUser = computed({
      get: () => store.state.auth.authUser,
    });
    onMounted(async () => {
      await mailingService.getReportTypes(
        isVind.value,
        authUser.value.customerId
      );
      await UserService.getProfileConfiguration();
      await UserService.getFavoriteAudienceTags(locale);
      await UserService.getFavoritePurposesTags(locale);
      await UserService.getFavoriteLocationsTags(locale);

      var locationsStr = "";
      for (let i = 0; i < favoriteLocations.value.length; i++) {
        // For German locations we send paths instead of ids
        if (
          locale.value === "de" &&
          favoriteLocations.value[i].path &&
          favoriteLocations.value[i].path != ""
        )
          locationsStr += favoriteLocations.value[i].path + ",";
        else locationsStr += favoriteLocations.value[i].id + ",";
      }
      locationsStr = locationsStr.substring(0, locationsStr.length - 1);

      checkForTagsUpdate();
      isLoadingDeadlineSchemes.value = true;
      isLoadingLatestNews.value = true;
      isLoadingNewestSchemes.value = true;
      if (!hasProfileTags.value) {
        await SchemesUtils.searchNewestSchemes(locale, 0, 20).then(
          () => (isLoadingNewestSchemes.value = false)
        );
        await SchemesUtils.searchDeadlineSchemes(locale, 0, 20).then(
          () => (isLoadingDeadlineSchemes.value = false)
        );
        await NewsUtils.searchLatestnews(0, 20).then(
          () => (isLoadingLatestNews.value = false)
        );
        await SchemesUtils.searchSignificantSchemes(0, 20, locale);
      } else {
        await SchemesUtils.searchNewestSchemesWithTags(
          locale,
          0,
          20,
          favoriteAudience.value,
          favoritePurposes.value,
          locationsStr
        ).then(() => (isLoadingNewestSchemes.value = false));

        await SchemesUtils.searchDeadlineSchemesWithTags(
          locale,
          0,
          20,
          favoriteAudience.value,
          favoritePurposes.value,
          locationsStr
        ).then(() => (isLoadingDeadlineSchemes.value = false));
        await NewsUtils.searchLatestnewsWithTags(
          0,
          20,
          favoriteAudience.value,
          favoritePurposes.value,
          locationsStr
        ).then(() => (isLoadingLatestNews.value = false));
        await SchemesUtils.searchSignificantSchemes(0, 20, locale);
      }
    });

    const hasProfileTags = ref(false);

    const checkForTagsUpdate = () => {
      if (
        favoriteAudience.value.length > 0 ||
        favoritePurposes.value.length > 0 ||
        favoriteLocations.value.length > 0
      ) {
        hasProfileTags.value = true;
      }
    };

    const isContrast = computed({
      get: () => store.state.user.isSelectedThemeContrast,
    });
    return {
      isVind,
      authUser,
      t,
      locale,
      isContrast,
      newestSchemes,
      latestNews,
      deadlineSchemes,
      favoriteAudience,
      favoritePurposes,
      favoriteLocations,
      hasProfileTags,
      significantChangesShemes,
      isLoadingLatestNews,
      isLoadingDeadlineSchemes,
      isLoadingNewestSchemes,
    };
  },
};
</script>
